// extracted by mini-css-extract-plugin
export default {"heroTop":"CampaignHeroTop_heroTop__qC7PX"};